import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { pathname } = useLocation();
  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.clientGeneral,
        label: 'General',
        permission: PERMISSIONS.clients.tabs.general.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.clientManagement,
        label: 'Client Management',
        permission: PERMISSIONS.clients.tabs.management.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.clientShipping,
        label: 'Shipping',
        permission: PERMISSIONS.clients.tabs.shipping.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.payments,
        label: 'Payments',
        permission: PERMISSIONS.clients.tabs.payments.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.clients.tabs.communicationHub.read,
        id: '5',
      },
      {
        path: ADMIN_ROUTES.clientTasks,
        label: 'Tasks',
        permission: PERMISSIONS.clients.tabs.task.read,
        id: '6',
      },
      {
        path: ADMIN_ROUTES.clientLogs,
        label: 'Logs',
        permission: PERMISSIONS.clients.tabs.logs.read,
        id: '7',
      },
    ];
    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
